import React from 'react';

import './index.scss';

export default function Forbidden(){
    return(<div className="forbidden">
        <div className="title">Access Forbidden</div>
        <div className="description">You don't have the necessary permission to access the content.</div>
    </div>)
}